import {is} from 'unist-util-is'
import { getNodeInfo } from '@/components/ReactMarkDown/nodeInfo.util'

const processCodeBlock = (node: any) => {
    const { data, newNode } = getNodeInfo(node);

    const obj = { data: {  
    hProperties: { 
        slot : 'code-block' 
    } 
    } };

    newNode.children.forEach((child: any, index: any) => {
    if (is(child, 'code') ) {
        Object.assign(child, obj);
    }
    })

    data.hName = 'var' 
    data.hProperties.class = 'code-example'
    data.hProperties.tabIndex = 0

}

export default processCodeBlock